import { styled, alpha, generateUtilityClasses } from '@mui/material';

export const COMPONENT_NAME = 'PrcSupplierOption';

export const supplierOptionClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['actions']),
};

export const Root = styled('li')({
  display: 'flex !important',
  flexDirection: 'row',
  position: 'relative',

  '&&': {
    paddingRight: 2,
  },

  [`&:hover .${supplierOptionClasses.actions}`]: {
    opacity: 1,
  },
});

export const Actions = styled('div')(({ theme }) => ({
  opacity: 0,
  position: 'absolute',
  right: 10,
  transition: theme.transitions.create(['opacity']),
  color: theme.palette.action.active,
  background: alpha('#f5f6f6', 0.8),
  borderRadius: 17,
}));
